import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Form, Input, Button, List } from 'antd';
import { jsPDF } from 'jspdf';
import { useReactToPrint } from 'react-to-print';
import '../index.css';
import Loader from '../components/Loader';

const ServerResult = () => {
    const [formData, setFormData] = useState({});
    const [scoreData, setScoreData] = useState({});
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        console.log(`Server Result ID: ${id}`);
        axios
            .get(`https://yanchacms.metadei.in/wp-json/wp/v2/stories-of-life/${id}`)
            .then((response) => {
                setLoading(false);
                const { json_body } = response.data;
                const parsed = JSON.parse(json_body);
                console.log(parsed);
                setFormData(parsed.formData);
                setScoreData(parsed.scoreData);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
        // Fetch or handle data logic using the ID
    }, [id]);

    // GET https://yanchacms.metadei.in/wp-json/story-of-life/v1/all
    // GET https://yanchacms.metadei.in/wp-json/wp/v2/stories-of-life/459

    const analyzeScore = (title, score) => {
        switch (title) {
            case "Bit Given At Birth":
                return "Rupam was born in a situation that allowed him to achieve any heights if right choices were made by him";
            case "Making Right Friends":
                return score === 10
                    ? "Rupam selected the Right Friends"
                    : "Rupam did not select the right friends";
            case "Hobbies and Interests":
                return score === 10
                    ? "Rupam chose the right hobby to develop self"
                    : "Rupam did not choose the right hobby to develop self";
            case "Education, Teachers and Influence":
                return score === 10
                    ? "Rupam selected the right subjects"
                    : "Rupam did not select the right subjects";
            case "Handling Distractions":
                return score === -10
                    ? "Rupam got distracted, but not too much"
                    : "Rupam got too distracted";
            case "Career Choice":
                return score === 10
                    ? "Rupam made the correct career choice based on the subject of interest"
                    : "Rupam could not make the correct career choice based on the subject chosen earlier";
            case "Role Model and Guide":
                return score === 20
                    ? "Rupam selected the right role model to guide and mentor him"
                    : "Rupam did not select the right role model";
            default:
                return "";
        }
    };

    // Exclude "overall" from analysis
    const analysis = Object.entries(scoreData)
        .filter(([title]) => title !== "overall")
        .map(([title, score]) => ({
            title,
            analysis: analyzeScore(title, score),
        }));

    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.text(`Name: ${formData.name}`, 10, 10);
        doc.text(`Age: ${formData.age}`, 10, 20);
        doc.text(`Phone: ${formData.phone}`, 10, 30);
        doc.text(`Email: ${formData.email}`, 10, 40);

        // Add analysis to PDF
        analysis.forEach((item, index) => {
            doc.text(`${item.title}: ${item.analysis}`, 10, 50 + index * 10);
        });

        // Add overall score to PDF
        doc.text(`Overall Score: ${scoreData.overall}`, 10, 50 + analysis.length * 10);

        doc.save('story_of_life_yancha.pdf');
    };

    const ScoreTable = ({ scoreData }) => {
        // Define max scores inside the component
        const maxScores = {
            "Bit Given At Birth": 100,
            "Making Right Friends": 15,
            "Hobbies and Interests": 10,
            "Education, Teachers and Influence": 10,
            "Handling Distractions": -20,
            "Career Choice": 10,
            "Role Model and Guide": 20,
            overall: 155, // Optional if "overall" doesn't have a max score
        };

        // Separate overall score from other scores
        const { overall, ...otherScores } = scoreData;

        // Combine other scores and maxScores into tableData
        const tableData = Object.entries(otherScores).map(([key, value], index) => ({
            key: index,
            category: key,
            score: value,
            maxScore: maxScores[key] || 0, // Default to 0 if no maxScore defined
        }));

        return (
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border">
                    <thead>
                        <tr className="bg-gray-200 gradient-small">
                            <th className="px-4 py-2 w-2/4 border-b border-r border-gray-300 text-gray-700 font-semibold text-left">
                                Category
                            </th>
                            <th className="px-4 py-2 w-1/4 border-b border-r border-gray-300 text-gray-700 font-semibold text-right">
                                Score
                            </th>
                            <th className="px-4 py-2 w-1/4 border-b border-r border-gray-300 text-gray-700 font-semibold text-right">
                                Max Possible Score
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row) => (
                            <tr key={row.key} className="hover:bg-gray-100">
                                <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-left txt txt-bold brand-text">
                                    {row.category}
                                </td>
                                <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-right">
                                    {row.score}
                                </td>
                                <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-right">
                                    {row.maxScore}
                                </td>
                            </tr>
                        ))}
                        {/* Render overall score last */}
                        <tr key="overall" className="hover:bg-gray-100">
                            <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-left txt txt-bold brand-text">
                                Overall
                            </td>
                            <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-right">
                                {overall}
                            </td>
                            <td className="px-4 py-2 border-b border-r border-gray-300 text-gray-800 text-right">
                                {maxScores.overall}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const printRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        pageStyle: `
            @page {
                size: auto,
                @botom-right-corner {
                    content: "Page " counter(page);
                }
            }
        `,
        documentTitle: 'Yancha Story of Life Report',
    });

    return (
        <>
            {
                loading ? <Loader /> :
                    <div>
                        <div ref={printRef} id="printableArea">
                            <div className='flex flex-col gap-4 justify-center items-center'>
                                <img src={require('../assets/yancha_pkt_logo.png')} width={150} alt="yancha" />
                                <p className='text-center text-3xl mb-[30px]'>Story of Life Results</p>
                            </div>

                            <div className="form-details mb-[20px] pl-[16px] pr-[16px]">
                                <div className='text-2xl font-bold mb-[10px]'>Details:</div>
                                <div className='txt brand-text flex flex-row gap-2 pb-[1px]'>
                                    <div className='w-1/3 font-semibold'>Name:</div>
                                    <div className='w-2/3 text-[18px] txt-survey'>{formData.name}</div>
                                </div>
                                <div className='txt brand-text flex flex-row gap-2 pb-[1px]'>
                                    <div className='w-1/3 font-semibold'>Age:</div>
                                    <div className='w-2/3 text-[18px] txt-survey'>{formData.age}</div>
                                </div>
                                <div className='txt brand-text flex flex-row gap-2 pb-[1px]'>
                                    <div className='w-1/3 font-semibold'>Phone:</div>
                                    <div className='w-2/3 text-[18px] txt-survey'>{formData.phone}</div>
                                </div>
                                <div className='txt brand-text flex flex-row gap-2 pb-[1px]'>
                                    <div className='w-1/3 font-semibold'>EMail:</div>
                                    <div className='w-2/3 text-[18px] txt-survey'>{formData.email}</div>
                                </div>
                            </div>
                            <div className='mb-[30px]'>
                                <p className='text-center text-2xl font-bold mt-[15px] mb-[20px]'>Score Sheet</p>
                                <ScoreTable scoreData={scoreData} />
                            </div>
                            <div className='mb-[30px]'>
                                <p className='text-center text-2xl font-bold mt-[15px] mb-[20px]'>Inferences</p>

                                <List
                                    dataSource={analysis}
                                    renderItem={({ title, analysis }) => (
                                        <li className="flex flex-row spacer pl-[16px] pr-[16px] gap-2">
                                            <p className="w-2/6 txt txt-bold brand-text">
                                                {title}:
                                            </p>
                                            <p className="w-4/6 txt brand-text">
                                                {analysis}
                                            </p>
                                        </li>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="flex justify-center mb-[15px]">
                            <div className="gradient-divider"></div>
                        </div>
                        <div className='flex justify-center mb-[30px]'>
                            <button
                                className='border-[#92278F] hover:border-[#F37741] bg-white hover:bg-[#92278F] rounded border-[2px] p-[15px] text brand-text text-bold hover:text-white'
                                onClick={handlePrint}
                            >
                                <p>Download Results as PDF</p>
                            </button>
                        </div>
                    </div>
            }
        </>

    );
};

export default ServerResult;